import React from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';

function RazorPayPaymentSuccessful() {
    const history = useHistory();
    const { lng } = useParams();

    const { search } = useLocation();
    const params = new URLSearchParams(search);

    const razorpay_payment_link_status = params.get("razorpay_payment_link_status") || 0;
    const isSuccess = ["success", "paid", "captured"].includes(razorpay_payment_link_status);
    const isFailure = ["failed", "failure", "cancelled", "canceled"].includes(razorpay_payment_link_status);
    const razorpay_payment_id = params.get('razorpay_payment_id')

    const goToBookingHistory = () => {
        const language = lng || localStorage.getItem('i18nextLng') || 'en';
        history.push(`/${language}/booking-history`);
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                {isSuccess && (
                    <>
                        <div style={styles.iconWrapper}>
                            <svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <polyline style={{ fill: 'none', stroke: '#27ae60', strokeWidth: 5, strokeLinecap: 'round', strokeLinejoin: 'round' }} points="14,27 22,35 38,17" />
                            </svg>
                        </div>
                        <h1 style={{ ...styles.title, color: '#27ae60' }}>Payment Successful</h1>
                        <p style={styles.subtitle}>Your payment has been processed successfully.</p>
                        {razorpay_payment_id && (
                            <p style={styles.paymentId}>
                                Payment ID: <span style={styles.paymentIdValue}>{razorpay_payment_id}</span>
                            </p>
                        )}
                        <p style={styles.closeText}>
                            You can <span style={styles.safelyText}>safely</span> close this window.
                        </p>
                        <button style={{ ...styles.button, border: '1.5px solid #2e86de', color: '#2e86de' }} onClick={goToBookingHistory}>
                            My Bookings
                        </button>
                    </>
                )}
                {isFailure && (
                    <>
                        <div style={styles.iconWrapper}>
                            <svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <line style={{ fill: 'none', stroke: '#e74c3c', strokeWidth: 5, strokeLinecap: 'round' }} x1="16" y1="16" x2="36" y2="36" />
                                <line style={{ fill: 'none', stroke: '#e74c3c', strokeWidth: 5, strokeLinecap: 'round' }} x1="36" y1="16" x2="16" y2="36" />
                            </svg>
                        </div>
                        <h1 style={{ ...styles.title, color: '#e74c3c' }}>Payment Failed</h1>
                        <p style={styles.subtitle}>Your payment could not be processed.</p>
                        <p style={styles.closeText}>Please try again or contact support if the issue persists.</p>
                        <button style={{ ...styles.button, border: '1.5px solid #e74c3c', color: '#e74c3c' }} onClick={goToBookingHistory}>
                            My Bookings
                        </button>
                    </>
                )}
                {!isSuccess && !isFailure && (
                    <>
                        <div style={styles.iconWrapper}>
                            <svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <polyline style={{ fill: 'none', stroke: '#27ae60', strokeWidth: 5, strokeLinecap: 'round', strokeLinejoin: 'round' }} points="14,27 22,35 38,17" />
                            </svg>
                        </div>
                        <h1 style={{ ...styles.title, color: '#27ae60' }}>Payment Successful</h1>
                        <p style={styles.subtitle}>Your payment has been processed successfully.</p>
                        <p style={styles.closeText}>
                            You can <span style={styles.safelyText}>safely</span> close this window.
                        </p>
                        <button style={{ ...styles.button, border: '1.5px solid #2e86de', color: '#2e86de' }} onClick={goToBookingHistory}>
                            My Bookings
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#eef0f8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: '14px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        padding: '48px 56px',
        textAlign: 'center',
        maxWidth: '420px',
        width: '100%',
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px',
    },
    icon: {
        width: '52px',
        height: '52px',
    },
    title: {
        fontSize: '24px',
        fontWeight: '700',
        margin: '0 0 12px 0',
    },
    subtitle: {
        fontSize: '14px',
        color: '#555555',
        margin: '0 0 8px 0',
    },
    closeText: {
        fontSize: '14px',
        color: '#555555',
        margin: '0 0 28px 0',
    },
    paymentId: {
        fontSize: '13px',
        color: '#555555',
        margin: '0 0 12px 0',
    },
    paymentIdValue: {
        fontWeight: '600',
        color: '#333333',
    },
    safelyText: {
        color: '#2e86de',
        fontWeight: '500',
    },
    button: {
        backgroundColor: 'transparent',
        borderRadius: '6px',
        padding: '10px 24px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s, color 0.2s',
    },
};

export default RazorPayPaymentSuccessful;
